module.exports = __webpack_public_path__ + "img/3dcc65293f53fc9bb55934c0bd83a1c1.png";